import { createTheme } from '@material-ui/core/styles';

// color .
import { grey } from '@material-ui/core/colors';

// custom theme
const customTheme = createTheme({
  spacing: 8,
  breakpoints: {
    xs: 0, sm: 375, md: 768, lg: 1024, xl: 1920,
  },
  palette: {
    primary: { main: '#033375', contrastText: '#fff' },
    secondary: { main: '#033375', contrastText: '#fff' },
    tertiary: { main: '#ff0000', contrastText: '#fff' },
    line: { main: grey[300] },
    background: {
      default: '#fff',
      grey: grey[300],
    },
  },
  typography: {
    fontFamily: [
      'Sarabun',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    fontKanit: [
      'Kanit',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Kanit',
    },
    h2: {
      fontFamily: 'Kanit',
    },
    h3: {
      fontFamily: 'Kanit',
    },
    h4: {
      fontFamily: 'Kanit',
    },
    h5: {
      fontFamily: 'Kanit',
    },
    h6: {
      fontFamily: 'Kanit',
    },
  },
  overrides: {
    MuiContainer: {
      root: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    MuiTableCell: {
      root: {
        padding: 8,
      },
      head: {
        // paddingTop: 14,
        // paddingBottom: 14,
        fontWeight: 'bold',
        // borderTop: `2px solid ${grey[300]}`,
        // borderBottom: `2px solid ${grey[300]}`,
      },
      body: {
        padding: 12,
        whiteSpace: 'nowrap',
        fontSize: '14px',
      },
    },
    MuiMenuItem: {
      root: {
        fontFamily: 'Kanit',
        fontSize: '14px',
      },
    },
    MuiSelect: {
      selectMenu: {
        fontFamily: 'Kanit',
        // fontSize: '14px',
      },
    },
    MuiButton: {
      outlinedSizeSmall: {
        fontFamily: 'Kanit',
        padding: '1px 6px',
        fontSize: '14px',
        fontWeight: 'inherit',
      },
    },
    MuiInputBase: {
      input: {
        fontFamily: 'Kanit',
        // fontSize: '14px',
      },
    },
    MuiTab: {
      wrapper: {
        fontSize: '16px',
        fontWeight: 'initial',
        flexDirection: 'row',
        fontFamily: 'Kanit',
        // whiteSpace: 'nowrap',
      },
      labelIcon: {
        minHeight: 0,
      },
    },
    MuiFormControl: {
      root: {
        width: '100%',
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 30,
      },
    },
    MuiSvgIcon: {
      fontSizeSmall: {
        // fontSize: 14,
      },
    },
  },
});

export default customTheme;
